// GOVGR_FIELD
export const GOVGR_FIELD = "govgr-field";
export const GOVGR_FIELD__ERROR = "govgr-field__error";

// GOVGR-LABEL
export const GOVGR_LABEL = "govgr-label";

// GOVGR-HEADING
export const GOVGR_HEADING_S = "govgr-heading-s";

// GOVGR_HINT
export const GOVGR_HINT = "govgr-hint";

// GOVGR_ERROR_MESSAGE
export const GOVGR_ERROR_MESSAGE = "govgr-error-message";

// GOVGR_VISUALLY_HIDDEN
export const GOVGR_VISUALLY_HIDDEN = "govgr-visually-hidden";

export const GOVGR_FILE_UPLOAD = "govgr-file-upload";

// GOVGR_BTN
export const GOVGR_BTN = "govgr-btn";
export const GOVGR_BTN_PRIMARY = "govgr-btn-primary";
export const GOVGR_BTN_WARNING = "govr-btn-warning";
export const GOVGR_BTN_DISABLED = "govgr-btn-disabled";
